import { MenuProps } from 'components/Menu/Types'
import { observer } from 'mobx-react-lite'
import { EditorColorPicker } from 'common/Prose/components/EditorColorPicker/EditorColorPicker'
import { CALLOUT_COLOR_OPTIONS, DEFAULT_CALLOUT_COLOR } from 'common/Prose/constants/colorOptions'
import { useCalloutButton } from 'components/DocRightRail/screens/FormatMenu/hooks/useCalloutButton'
import Styles from './ColorPicker.module.scss'

export const CalloutSubMenu = observer(({ onAction }: Pick<MenuProps<any>, 'menuType' | 'onAction'>) => {
  const { activeColors, setColor, removeColor } = useCalloutButton()

  return (
    <span className={Styles.root}>
      <EditorColorPicker
        aria-label={(color: string) => `Change callout color to ${color}`}
        colorOptions={CALLOUT_COLOR_OPTIONS}
        activeColors={activeColors}
        setColor={(color) => {
          setColor(color)
          onAction?.(color)
        }}
        noColorButtonPos="bottom"
        noColorButtonLabel="Remove"
        defaultColor={DEFAULT_CALLOUT_COLOR}
        removeColor={() => {
          removeColor()
        }}
        includeDropdownStyles={false}
      />
    </span>
  )
})
